import { autoGeneratedReducer } from '@hh.ru/redux-create-reducer';

import { CompetitorAnalysisParams } from 'src/models/competitorAnalysis';
import { ReportTabs } from 'src/models/competitorAnalysisReportTab';

interface VacancyParams extends Omit<CompetitorAnalysisParams, 'professionalRole'> {
    employerName: string;
    areaName: string;
    professionalRole: { id: string; name: string };
}

export interface CompetitorAnalysisReport {
    formUrl: string;
    reportDataUrl: string;
    reportParams: CompetitorAnalysisParams;
    reportTabs: ReportTabs[];
    vacancy: VacancyParams;
}

export default autoGeneratedReducer<Partial<CompetitorAnalysisReport>>({});
